export default __webpack_public_path__ + "static/media/drep2.f3b0ebca.jfif";